import LogList from "./components/List"

let module = "logs"

export default [
  {
    path: "logs",
    component: LogList,
    meta: { module: module, permissions: ["log-access"] },
  },
]
